// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"milk"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16.85 4.8V2H12H7.15V4.8L5 9.7V22H19V9.7L16.85 4.8Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15.05 22H19V9.7L16.85 4.8V2H7.15V4.8L5 9.7V22H15.05ZM15.05 22V9.7L16.625 5.4125M5.5 9.7H14.55M7.65 4.8H16.35","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8 18V14H8.001L10 16L11.99 14H12V18","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-milk')
export default class MilkIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'milk',
    }
  }
}
